import linkedinicon from "../icons/linkedin-phn.png";
import instagramicon from "../icons/instagram.png";
import emailicon from "../icons/email-phn.png";
import githubicon from "../icons/github-phn.png";
import twittericon from "../icons/twitter-phn.png";
import whatsappicon from "../icons/whatsapp.png";
import codecheficon from "../icons/codechef-phn.png";
import "./Contactform.css";
import React, { useRef, useState } from "react";
import emailjs from "@emailjs/browser";
import { ToastContainer, toast } from "react-toastify";
import icons from "../pics/logo.png"
import "react-toastify/dist/ReactToastify.css";
import useSound from "use-sound";
import connect from "../utils/sounds/connect.mp3";
function ContactForm() {
  const form = useRef();
  const [connectSound] = useSound(connect);

  const sendEmail = (e) => {

    e.preventDefault();

    emailjs
      .sendForm(
        "service_ve3vj0a",
        "template_lrhby8p",
        form.current,
        "TR_Lrj9LH-LJg-lK9"
      )
      .then(
        (result) => {
          toast.success("Message Sent",{theme:"dark"},{icon: icons});
          // console.log(result.text);
    connectSound();

        },
        (error) => {
          toast.error("Message not Sent",{theme:'dark'});
          // console.log(error.text);
        }
      );

    setname("");
    setemail("");
    setmessage("");
  };

  const [name, setname] = useState("");
  const [email, setemail] = useState("");
  const [message, setmessage] = useState("");

  const linkedinlink = "https://www.linkedin.com/in/ankit-kumar-709b99162/";
  const githublink = "https://github.com/ank-2222";
  const codecheflink = "https://www.codechef.com/users/ank_222";
  const twitterlink = "https://twitter.com/ankitkum_12";
  const emaillink = "mailto:ankit.2222kumar2002@gmail.com";

  return (
    <form className="form" id="form" ref={form} onSubmit={sendEmail}>
      <div className="form-main">
        <h1 className="form-head">Let's talk.</h1>
        <p className="form-p">New projects, any inquiry</p>
        <div className="form-element">
          <div>Name</div>
          <input
            placeholder="Jane Doe"
            type="text"
            name="user_name"
            className="input-val"
            onChange={(event) => setname(event.target.value)}
            value={name}
            required
          />
        </div>

        <div className="form-element">
          <div>Email</div>
          <input
            placeholder="jane@doe.com"
            type="email"
            name="user_email"
            className="input-val"
            onChange={(event) => setemail(event.target.value)}
            value={email}
            required
          />
        </div>
        <div className="form-element">
          {" "}
          <div>Message</div>
          <textarea
            placeholder="Write your thoughts..."
            name="message"
            className="input-val"
            onChange={(event) => setmessage(event.target.value)}
            value={message}
            required
          />
        </div>

        <div className="form-element">
          <button className="send-btn" type="submit" value="Send">
            Send
          </button>
        </div>
      </div>

      <div className="d-flex contact-icon">
        <div className="home-social-icon">
          <a target="_blank" href={linkedinlink}>
            <img src={linkedinicon}></img>
          </a>
        </div>
        <div className="home-social-icon">
          <a target="_blank" href={githublink}>
            <img src={githubicon}></img>
          </a>
        </div>
        <div className="home-social-icon">
          <a target="_blank" href={codecheflink}>
            <img src={codecheficon}></img>
          </a>
        </div>

        <div className="home-social-icon">
          <a target="_blank" href={emaillink}>
            <img src={emailicon}></img>
          </a>
        </div>
        <div className="home-social-icon">
          <a target="_blank" href={twitterlink}>
            <img src={twittericon}></img>
          </a>
        </div>
      </div>
      {/* <div><h4>Regards,</h4></div> */}
    </form>
  );
}

export default ContactForm;
